var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"indicator"},[_c('div',{class:`indicator__icon ${_vm.status ? 'indicator__icon_online': ''}`}),_vm._v(" "+_vm._s(_vm.status ? 'Impresora conectada' : 'Impresora desconectada')+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }